<template>

    <Toast/>

    <div class="px-6 surface-overlay relative">

        <div class="py-3 lg:py-3 px-6 flex align-items-center justify-content-between lg:static">
            <img src="images/blocks/logos/logo.simplyinvesting.rev2.png" alt="Simply Investing" height="50"
                 class="mr-0 lg:mr-6">
        </div>

        <div class="surface-section px-4 py-8 md:px-6 lg:px-8 overflow-hidden">

            <div class="grid">
                <div class="col-12 md:col-12">
                    <div class="card p-fluid">

                        <h2>Submit New Password</h2>

                        <div class="field">
                            <span>Enter your new password below. If the
                                    activation code matches our records, and it's still valid, the password will be reset. If not,
                                    please start a new password request.
                            </span>
                        </div>

                        <div class="field">
                            <label for="activationCode">Activation Code</label>
                            <InputText id="activationCode" type="text" :disabled="false" v-model.trim="activationCode"/>
                        </div>

                        <div class="field">
                            <label for="password1">New Password</label>
                            <InputText id="password1" :type="showPassword ? 'text' : 'password'" v-model.trim="password1"/>

                            <small v-if="!password1" class="p-error">Password is required. </small>
                            <small v-if="password1 != password2" class="p-error">Passwords must match. </small>
                        </div>

                        <div class="field">
                            <label for="password2">Verify Password</label>
                            <InputText id="password2" :type="showPassword ? 'text' : 'password'" v-model.trim="password2"/>

                            <small v-if="!password2" class="p-error">Password is required. </small>
                            <small v-if="password1 != password2" class="p-error">Passwords must match. </small>
                        </div>

                        <Button
                            label="Reset Password"
                            :disabled="!isFormValid"
                            class="p-3 w-full mt-auto custom-button"
                            :loading="submitted"
                            @click="processResetPassword"
                        />

                        <div class="field">
                            &nbsp;
                        </div>

                        <div class="flex align-items-center justify-content-between mb-6">
                            <div class="flex align-items-center">
                                <Checkbox id="showPasswordToggle" :binary="true" v-model="showPassword" class="mr-2"></Checkbox>
                                <label for="showPasswordToggle">Show Password</label>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <SiFooter/>

</template>

<script>
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";

export default {
    components: {SiFooter},
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    mounted() {
        UserService.getUserPing()
            .then(data => {
                console.log("[ForgotPasswordSubmission][mounted] System is active.");
                console.log("[ForgotPasswordSubmission][mounted] Data = ", data);
            })
            .catch(e => {
                console.log("[ForgotPasswordSubmission][mounted] System is NOT active.");
                console.log("[ForgotPasswordSubmission][mounted] Error = ", e);

                this.userStore.clearUser();
                this.$router.replace('/siLogin');
                return;
            });

        document.title = "Simply Investing"; // Update the browser tab title
        this.setFavicon("images/blocks/logos/favicon.simplyinvesting.96x96.png");

        this.activationCode = this.$route.query.code;

        console.log("[ForgotPasswordSubmission][mounted] this.activationCode = ", this.activationCode);
    },
    data() {
        return {
            submitted: false,
            companyId: 114951,
            password1: null,
            password2: null,
            activationCode: null,
            passwordError: false,
            showPassword: false
        }
    },
    computed: {
        isFormValid() {
            // Check if all required fields are filled and email is valid
            return (
                this.password1 &&
                this.password2 &&
                (this.password1 === this.password2)
            );
        },
    },
    methods: {
        setFavicon(url) {
            // Check if a <link rel="icon"> tag already exists
            let faviconLink = document.querySelector("link[rel='icon']");

            if (!faviconLink) {
                // Create a new <link> element if one doesn't exist
                faviconLink = document.createElement("link");
                faviconLink.rel = "icon";
                document.head.appendChild(faviconLink);
            }

            // Update the favicon URL
            faviconLink.href = url;
        },
        async processResetPassword() {
            console.log("[ForgotPasswordSubmission][processResetPassword] this.email = ", this.email);

            this.submitted = true;

            if (this.isFormValid) {

                try {

                    var resetPasswordRequestDto = {
                        activationCode: this.activationCode,
                        password: this.password1
                    };

                    const response = await UserService.resetPasswordActivation(resetPasswordRequestDto);
                    console.log('[ForgotPasswordSubmission][processResetPassword] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Successfully reset password.',
                        life: 3000
                    });

                    setTimeout(() => {
                        window.location.href = "/#/siLogin";
                    }, 1000);

                } catch (error) {
                    console.error('[ForgotPasswordSubmission][processResetPassword] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to reset password. Please try again.',
                        life: 3000
                    });

                    setTimeout(() => {
                        window.location.href = "/#/siLogin";
                    }, 1000);
                }
            }

            this.submitted = false;
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}

.custom-button {
    background-color: #2E5439; /* Button background color */
    color: white; /* Button text color */
    border: none; /* Remove border if needed */
}

.custom-button:hover {
    background-color: #3E6948; /* Slightly lighter shade for hover effect */
}
</style>
